var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1998_1930)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 12.4167C11.7293 12.4167 12.4288 12.1269 12.9445 11.6112C13.4603 11.0955 13.75 10.396 13.75 9.66666C13.75 8.93731 13.4603 8.23784 12.9445 7.72211C12.4288 7.20639 11.7293 6.91666 11 6.91666C10.2707 6.91666 9.57118 7.20639 9.05546 7.72211C8.53973 8.23784 8.25 8.93731 8.25 9.66666C8.25 10.396 8.53973 11.0955 9.05546 11.6112C9.57118 12.1269 10.2707 12.4167 11 12.4167Z",
    stroke: "#FF626A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.68433 17.682C5.9265 16.9498 6.39339 16.3125 7.0186 15.8609C7.64381 15.4093 8.3955 15.1664 9.16674 15.1667H12.8334C13.6042 15.1664 14.3554 15.409 14.9804 15.8601C15.6054 16.3111 16.0723 16.9477 16.3149 17.6792",
    stroke: "#FF626A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2188 6.2475C18.8604 6.61233 19.2546 7.29525 19.25 8.03317V14.7102C19.25 15.4517 18.8439 16.1356 18.1885 16.4958L12.001 20.41C11.6942 20.5784 11.35 20.6667 11 20.6667C10.6501 20.6667 10.3058 20.5784 9.999 20.41L3.8115 16.4958C3.49082 16.3206 3.22311 16.0624 3.03638 15.7483C2.84964 15.4341 2.75073 15.0756 2.75 14.7102V8.03225C2.75 7.29067 3.15608 6.60775 3.8115 6.2475L9.999 2.59917C10.3148 2.42503 10.6696 2.33371 11.0303 2.33371C11.3909 2.33371 11.7457 2.42503 12.0615 2.59917L18.249 6.2475H18.2188Z",
    stroke: "#FF626A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1998_1930"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.aaa245fd87701035fa45fe5890baf5e0.svg";
export { ForwardRef as ReactComponent };